webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Hawkins Landscape Services","phone":"301-500-7327"}}},"layoutContext":{}}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-alt.4ae16c7e.svg";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  body { background-color: ', '; }\n'], ['\n  body { background-color: ', '; }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  height: 100vh;\n'], ['\n  display: flex;\n  height: 100vh;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255,255,255,0.667);\n\n  @media (min-width: ', ') {\n    display: none !important;\n  }\n'], ['\n  position: fixed;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255,255,255,0.667);\n\n  @media (min-width: ', ') {\n    display: none !important;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 3;\n  left: 0;\n  transition: left .2s ease-in-out;\n  height: 100%;\n  width: ', ';\n  max-width: 100vw;\n  overflow-y: auto;\n  background-color: ', ';\n  border-right: 1px solid #005264;\n\n  @media (min-width: ', ') {\n    left: 0 !important;\n  }\n'], ['\n  position: fixed;\n  z-index: 3;\n  left: 0;\n  transition: left .2s ease-in-out;\n  height: 100%;\n  width: ', ';\n  max-width: 100vw;\n  overflow-y: auto;\n  background-color: ', ';\n  border-right: 1px solid #005264;\n\n  @media (min-width: ', ') {\n    left: 0 !important;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n\n  > a {\n    padding: 0.5em 1.5em;\n    font-family: ', ';\n    text-decoration: none;\n    text-transform: uppercase;\n    display: block;\n    color: ', ';\n  }\n'], ['\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n\n  > a {\n    padding: 0.5em 1.5em;\n    font-family: ', ';\n    text-decoration: none;\n    text-transform: uppercase;\n    display: block;\n    color: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 100%;\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 100%;\n\n  @media (min-width: ', ') {\n    padding-left: ', ';\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  background-color: ', ';\n  color: white;\n  font-size: 1.125rem;\n  font-family: ', ';\n  font-weight: bold;\n  border-bottom: 1px solid #005264;\n\n  button {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    font-size: 1.25rem;\n    border: 1px solid transparent;\n    background-color: transparent;\n    color: white;\n  }\n\n  @media (min-width: ', ') {\n    display: none;\n  }\n'], ['\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  background-color: ', ';\n  color: white;\n  font-size: 1.125rem;\n  font-family: ', ';\n  font-weight: bold;\n  border-bottom: 1px solid #005264;\n\n  button {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    font-size: 1.25rem;\n    border: 1px solid transparent;\n    background-color: transparent;\n    color: white;\n  }\n\n  @media (min-width: ', ') {\n    display: none;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  margin-top: 3.125rem;\n\n  @media (min-width: ', ') {\n    margin-top: auto;\n  }\n'], ['\n  flex: 1;\n  margin-top: 3.125rem;\n\n  @media (min-width: ', ') {\n    margin-top: auto;\n  }\n']);
	
	var _gatsbyLink = __webpack_require__(161);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _logoAlt = __webpack_require__(465);
	
	var _logoAlt2 = _interopRequireDefault(_logoAlt);
	
	var _theme = __webpack_require__(16);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _theme2.default.colors.bg);
	
	var Site = _styledComponents2.default.div(_templateObject2);
	
	var Cover = _styledComponents2.default.div(_templateObject3, _theme2.default.app.mobileBreakpoint);
	
	var Header = _styledComponents2.default.header(_templateObject4, _theme2.default.app.headerWidth, _theme2.default.colors.darkBlack, _theme2.default.app.mobileBreakpoint);
	
	var Nav = _styledComponents2.default.nav(_templateObject5, _theme2.default.fonts.sans, _theme2.default.colors.lightTeal);
	
	var Main = _styledComponents2.default.main(_templateObject6, _theme2.default.app.mobileBreakpoint, _theme2.default.app.headerWidth);
	
	var TitleBar = _styledComponents2.default.div(_templateObject7, _theme2.default.colors.darkTeal, _theme2.default.fonts.sans, _theme2.default.app.mobileBreakpoint);
	
	var MainContent = _styledComponents2.default.div(_templateObject8, _theme2.default.app.mobileBreakpoint);
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { isShowingHeader: false };
	    _this.hideHeader = _this.hideHeader.bind(_this);
	    _this.showHeader = _this.showHeader.bind(_this);
	    return _this;
	  }
	
	  Layout.prototype.hideHeader = function hideHeader() {
	    this.setState({ isShowingHeader: false });
	  };
	
	  Layout.prototype.showHeader = function showHeader() {
	    this.setState({ isShowingHeader: true });
	  };
	
	  Layout.prototype.render = function render() {
	    var actions = {
	      hideHeader: this.hideHeader,
	      showHeader: this.showHeader
	    };
	
	    return _react2.default.createElement(
	      Site,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          this.props.data.site.siteMetadata.title
	        ),
	        _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://use.typekit.net/ahw0yta.css' }),
	        _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://use.fontawesome.com/releases/v5.0.10/css/all.css' }),
	        _react2.default.createElement('meta', { name: 'google-site-verification', content: 'gQ5FNjpRFo4pf4wk-Z-xjXrKhFAUrw_Vbsc-d7KcwqE' })
	      ),
	      _react2.default.createElement(
	        Header,
	        { style: {
	            left: this.state.isShowingHeader ? '0' : '-' + _theme2.default.app.headerWidth
	          } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', onClick: this.hideHeader },
	          _react2.default.createElement('img', { src: _logoAlt2.default, style: { padding: '1em 1.5em' } })
	        ),
	        _react2.default.createElement(
	          Nav,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about/', onClick: this.hideHeader },
	            'About'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/', onClick: this.hideHeader },
	            'Services'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/gallery/', onClick: this.hideHeader },
	            'Gallery'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/testimonials/', onClick: this.hideHeader },
	            'Testimonials'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/media/', onClick: this.hideHeader },
	            'Media'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact/', onClick: this.hideHeader },
	            'Contact'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Main,
	        null,
	        _react2.default.createElement(
	          TitleBar,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'link',
	                onClick: this.showHeader },
	              _react2.default.createElement('i', { className: 'fas fa-bars' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginLeft: '0.25rem' } },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: '/', onClick: this.hideHeader,
	                style: { color: 'white', textDecoration: 'none' } },
	              this.props.data.site.siteMetadata.title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          MainContent,
	          null,
	          this.props.children(_extends({}, this.props, actions))
	        )
	      ),
	      _react2.default.createElement(Cover, {
	        onClick: this.hideHeader,
	        style: {
	          display: this.state.isShowingHeader ? 'block' : 'none'
	        } })
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-110b0fa4a18acc0e249e.js